const BASE = import.meta.env.VITE_API_BASE ?? '';

export interface RuoYiPage<T> {
  code: number;
  msg: string;
  total: number;
  rows: T[];
}

export async function request<T>(url: string, params?: Record<string, unknown>): Promise<T> {
  const qs = params
    ? '?' + new URLSearchParams(
        Object.entries(params)
          .filter(([, v]) => v !== undefined && v !== null && v !== '')
          .map(([k, v]) => [k, String(v)]),
      ).toString()
    : '';
  const res = await fetch(BASE + url + qs, {
    headers: { 'Content-Type': 'application/json;charset=utf-8' },
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const data = await res.json();
  if (data.code !== undefined && data.code !== 200) {
    throw new Error(data.msg || `业务错误 ${data.code}`);
  }
  return data as T;
}

export async function post<T>(url: string, body?: unknown): Promise<T> {
  const res = await fetch(BASE + url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf-8' },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const data = await res.json();
  if (data.code !== undefined && data.code !== 200) {
    throw new Error(data.msg || `业务错误 ${data.code}`);
  }
  return data as T;
}
